import { useState , useEffect } from 'react'
import { useNavigate } from 'react-router-dom';
import './Admin.css'
import axios from 'axios';
import Nav from '../nav_home/nav_home'
const url='https://personal-portfolio-theta-blue.vercel.app/admin'


function Admin() {
  const history=useNavigate();

  const [formdata,setformdata]=useState({username:'',password:''});

  useEffect(()=>{
    if(localStorage.getItem('auth')=='true'){
      history('/adminactions')
    }
  },[])

  function usernameHandler(e){
    setformdata({...formdata,username:e.target.value});
  }
  function passwordHandler(e){
    setformdata({...formdata,password:e.target.value});
  }

  async function formHandler(e){
    e.preventDefault();
    try{
      await axios.post(url, formdata)
      .then((res)=>{
        console.log(res);
        if (res.status==200) {
          localStorage.setItem('auth',true)
          history('/adminactions');
        }
      })
      .catch((err)=>{
        console.log(err);
        alert("Invalid Username or Password !")
      })
    }catch(error){
      console.log(error)
    }
    //window.location.reload()
  }

  return (
    <div className="CertificateUpload">
      <form onSubmit={formHandler} className='certificateUploadForm'>
        <h1>Login</h1>
        <input 
          type="text"
          name="username"
          id='username'
          required
          placeholder='Enter your username or Email ID'
          onChange={(event)=>usernameHandler(event)}
          autoComplete='off'
         />
         <input 
          type="text"
          name="password"
          id='password'
          required
          placeholder='Enter your password'
          onChange={(event)=>passwordHandler(event)}
          autoComplete='off'
         />
         <button type='submit' className='btn btn-primary'>Submit</button>
      </form>
      <Nav/>
    </div>
  )
}

export default Admin
